import {css} from 'styled-components';
import logoLfs from './icons/lfs/logo-longfonds.png';
import progress1 from './icons/lfs/step-indicator-1.svg';
import progress2 from './icons/lfs/step-indicator-2.svg';
import progress3 from './icons/lfs/step-indicator-3.svg';
import progress1of2 from './icons/lfs/step-indicator-1of2.svg';
import progress2of2 from './icons/lfs/step-indicator-2of2.svg';
import whatsapp from './icons/sho/whatsapp.png';
import facebook from './icons/sho/facebook.svg';
import twitter from './icons/sho/x.svg';
import linkedin from './icons/sho/linkedin.svg';
import instagram from './icons/sho/instagram.svg';
import checkmark from './icons/lfs/checkmark.png';

const primaryColor = '#424346';
const primary = '#F0007D';
const errorColor = '#FF3B30';

const lightBlue = '#DDE1F3';

export default {
  // GlobalStyles
  bodyFontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
  h1FontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
  h3FontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
  h1FontSize: '26px',
  bodyFontSize: '16px',
  color: primaryColor,
  background: css`
    background-image: ${props => `url('${props.backgroundImageUrl}')`};
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    position: fixed;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    z-index: -10;
    background-size: cover;

    @media (min-width: 769px) and (max-width: 1024px) {
      background-image: ${props => `url('${props.backgroundImageTabletUrl}')`};
      background-position-y: top;
      background-position-x: left;
      background-attachment: local;
      left: -240px;
    }

    @media (max-width: 768px) {
      background-image: ${props => `url('${props.backgroundImageMobileUrl}')`};
      width: 100%;
      height: 100%;
      background-color: white;
      background-size: contain;
      background-position-y: top;
      background-position-x: center;
      background-repeat: no-repeat;
      inset: initial;
      z-index: -1;
      background-attachment: local;
      position: absolute;
    }
  `,
  // AmountButton
  amountButton: {
    color: primaryColor,
    inactiveColor: primaryColor,
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '18px',
    width: 'calc(50% - 6.5px)',
    height: '56px',
    border: `1px solid ${primaryColor}`,
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: '#F3FFE1',
    borderHover: `1px solid ${primaryColor}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
  },
  frequencyButton: {
    color: primaryColor,
    inactiveColor: primaryColor,
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '18px',
    width: 'calc(50% - 6.5px)',
    height: '56px',
    border: `1px solid ${primaryColor}`,
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: '#F3FFE1',
    borderHover: `1px solid ${primaryColor}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
  },
  buttonContainerSpaceBetween: {
    width: '30%'
  },
  frequencyButtonContainer: {
    width: '30%'
  },
  //BackButton
  backButton: {
    fontSize: '12px',
    color: '#8F9399'
  },
  // Box
  boxComponent: {
    borderRadius: '4px'
  },
  // Button
  button: {
    borderRadius: '4px',
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '20px',
    height: '56px',
    backgroundColor: primary,
    color: '#fff',
    boxShadow: 'none',
    borderBottom: '1px #781e1e solid',
    active: css`
      background-color: ${primary};
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: ${primary};
    `,
    focus: css`
      box-shadow: none;
    `
  },
  // Checkbox
  inputCheckbox: {
    border: '1px solid #E4E7ED'
  },
  box: {
    fontSize: '14px',
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`,
    borderHover: '1px solid #8F9399',
    backgroundColorChecked: primary,
    backgroundBorderChecked: '1px solid #8F9399'
  },
  // Collecting
  collecting: {
    imageTopRight: true,
    height: '60px',
    heightMobile: '60px',
    margin: '30px 16px 20px 0',
    marginMobile: '30px 16px 20px 0'
  },
  // DateInput
  dateDropdown: {
    padding: '10px 30px 12.4px 10px',
    border: '1px solid #E4E7ED',
    boxShadowFocus: '0 0 0 3px #E4E7ED',
    borderFocus: '1px solid transparent',
    boxShadowError: `0 0 0 3px ${errorColor}`,
    boxShadowValid: '0 0 0 3px #8F9399'
  },
  // DisplayIban
  iban: {
    fontFamily: 'Gilroy-Regular, "Open Sans", Arial, sans-serif;',
    color: '#fff'
  },
  // Dropdown
  dropdown: {
    height: '46px',
    borderRadius: '4px',
    backgroundColor: '#fff',
    fontSize: '18px',
    paddingLeft: '13px',
    border: '1px solid transparent',
    boxShadow: '0 0 0 2px #E4E7ED',
    boxShadowFocus: '0 0 0 3px #8F9399',
    boxShadowError: `0 0 0 3px ${errorColor}`,
    boxShadowValid: '0 0 0 3px #8F9399'
  },
  // ErrorMessage
  error: {
    backgroundColor: '#F1F4FA',
    color: errorColor,
    height: '49px'
  },
  // Iban
  ibanContainer: {
    display: 'none'
  },
  // Input
  inputComponent: {
    fontSize: '16px',
    border: '1px solid #E4E7ED',
    borderFocus: '1px solid transparent',
    boxShadowFocus: '0 0 0 3px #8F9399',
    colorPlaceholder: '#E4E7ED',
    borderValid: 'none',
    boxShadowValid: '0 0 0 3px #078b62',
    backgroundColorValid: '#F3FFE1',
    borderError: 'none',
    boxShadowError: `0 0 0 3px ${errorColor}`,
    colorError: errorColor,
    backgroundColorError: '#fff'
  },
  // TextArea
  textAreaComponent: {
    fontSize: '16px',
    border: '1px solid #E4E7ED',
    borderFocus: '1px solid transparent',
    boxShadowFocus: '0 0 0 3px #8F9399',
    colorPlaceholder: '#E4E7ED',
    borderValid: 'none',
    boxShadowValid: '0 0 0 3px #078b62',
    backgroundColorValid: '#F3FFE1',
    borderError: 'none',
    boxShadowError: '0 0 0 3px #dc281e',
    colorError: errorColor,
    backgroundColorError: '#FFE5E6'
  },
  // Label
  optionalLabel: {
    color: '#8F9399'
  },
  label: {
    fontSize: '14px',
    color: primaryColor,
    colorError: errorColor
  },
  logo: {
    width: '69px',
    height: '60px',
    backgroundImage: logoLfs,
    widthMobile: '69px',
    heightMobile: '60px',
    margin: '30px 0 20px -4px',
    marginMobile: '30px 0 20px 16px'
  },
  // PaymentButton
  paymentButton: {
    color: primaryColor,
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '11px',
    width: 'calc(36% - 10px);',
    height: '56px',
    lineHeight: '45px',
    border: '1px solid #E4E7ED',
    borderRadius: '4px',
    backgroundColor: '#fff',
    backgroundColorActive: '#F3FFE1',
    borderHover: `1px solid ${primaryColor}`,
    boxShadowHover: `inset 0px 0px 0px 1px ${primaryColor}`
  },
  // ProgressBar
  progressBar: {
    step1: css`
      width: 70px;
      background: url(${progress1}) no-repeat 0;
    `,
    step2: css`
      width: 70px;
      background: url(${progress2}) no-repeat 0;
    `,
    step3: css`
      width: 70px;
      background: url(${progress3}) no-repeat 0;
    `,
    step1of2: css`
      width: 40px;
      background: url(${progress1of2}) no-repeat 0;
    `,
    step2of2: css`
      width: 40px;
      background: url(${progress2of2}) no-repeat 0;
    `
  },
  // RadioButton
  inputRadioButton: {
    backgroundColor: '#fff',
    border: '1px solid #E4E7ED',
    backgroundColorDisabled: '#E4E7ED',
    backgroundColorActive: '#8F9399',
    borderActive: '1px solid #8F9399',
    borderDisabled: '1px solid #E4E7ED'
  },
  radio: {
    borderHover: '1px solid #8F9399',
    colorHasError: errorColor,
    borderHasError: `1px solid ${errorColor}`
  },
  // TeaserHeader
  teaser: {
    hideOnMobile: true,
    display: 'inline',
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontWeight: '600',
    fontSize: '32px',
    lineHeight: '47px',
    color: '#fff',
    colorSubtitle: '#fff',
    padding: '3px 5px',
    fontSizeTablet: '32px',
    lineHeightTablet: '47px',
    fontSizeWide: '32px',
    lineHeightWide: '47px',
    subtitleFontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    subtitleFontSize: '18px',
    subtitleLineHeight: '31px',
    subtitleFontSizeWide: '18px',
    subtitleLineHeightWide: '31px',
    subtitleFontSizeTablet: '18px',
    subtitleLineHeightTablet: '31px',
    paddingTop: '0',
    // paddingTopSubtitle: '0',
    topLeftTextAlignment: 'left',
    topRightTextAlignment: 'right',
    bottomLeftTextAlignment: 'left',
    bottomRightTextAlignment: 'right'
  },
  teaserContainer: {
    margin: '10px 0 0 0'
  },
  // Title
  title: {
    color: primaryColor,
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '18px',
    height: '60px',
    fontWeight: '500',
    borderRadius: '4px',
    backgroundColor: lightBlue,
    widthProperty: 'max-width: 280px;'
  },
  // Validation
  validation: {
    color: errorColor,
    fontSize: '16px'
  },
  // OptIn
  optInButton: {
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '20px',
    backgroundColor: '#B9BDDF',
    color: '#fff',
    boxShadow: 'none',
    active: css`
      background-color: #B9BDDF;
      border-bottom: none;
      box-shadow: none !important;
    `,
    hover: css`
      background-color: #B9BDDF;
    `,
    focus: css`
      box-shadow: none;
    `
  },
  // PersonalMessage
  personalMessage: {
    fontFamily: 'Gilroy-Medium, "Open Sans", Arial, sans-serif;',
    fontSize: '20px',
    backgroundColor: lightBlue,
    color: primaryColor,
    boxShadow: 'none',
    active: css`
      border-bottom: none;
      box-shadow: none !important;
    `,
    focus: css`
      box-shadow: none;
    `,
    checkmarkColor: primary,
    checkmark: css`
      background: url(${checkmark}) no-repeat 0;
      width: 35px;
      height: 20px;
      display: inline-block;
    `
  },
  // SocialShareButton
  socialShareButton: {
    backgroundSize: '50px',
    color: primaryColor,
    whatsapp: css`background-image: url(${whatsapp})`,
    facebook: css`background-image: url(${facebook})`,
    twitter: css`background-image: url(${twitter})`,
    linkedin: css`background-image: url(${linkedin})`,
    instagram: css`background-image: url(${instagram})`
  },
  privacyLabel: {
    standard: {
      fontSize: '12px'
    }
  },
  amountText: {
    boldFrequency: true
  }
};


